export const ACCOUNT_SETTINGS_SIDERBAR = "ACCOUNT_SETTINGS_SIDERBAR";
export const ACCOUNT_SETTINGS_SAVE = "ACCOUNT_SETTINGS_SAVE";
export const ACCOUNT_SETTINGS_SAVE_RESPONSE = "ACCOUNT_SETTINGS_SAVE_RESPONSE";
export const GET_PREFERENCE = "GET_PREFERENCE"
export const GET_PREFERENCE_RESULT = "GET_PREFERENCE_RESULT"